import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	timeGoal: {
		id: 'servicedesk-sla-settings.common.goals.goal-header.time-goal',
		defaultMessage: 'Time Goal',
		description: 'header for time goal column',
	},
	timeTarget: {
		id: 'servicedesk-sla-settings.common.goals.goal-header.time-target',
		defaultMessage: 'Time target',
		description: 'header for time goal column',
	},
	calendar: {
		id: 'servicedesk-sla-settings.common.goals.goal-header.calendar',
		defaultMessage: 'Calendar',
		description: 'header for calendar column',
	},
	jql: {
		id: 'servicedesk-sla-settings.common.goals.goal-header.jql',
		defaultMessage: 'Issues to display (in JQL)',
		description: 'header for Jql column',
	},
	applyToIssues: {
		id: 'servicedesk-sla-settings.common.goals.goal-header.apply-to-issues',
		defaultMessage: 'Apply to issues',
		description: 'header for Jql column',
	},
});
